/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Banner_Trusted_ByInputs */

const en_homepage_banner_trusted_by = /** @type {(inputs: Homepage_Banner_Trusted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trusted by`)
};

const es_homepage_banner_trusted_by = /** @type {(inputs: Homepage_Banner_Trusted_ByInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizado por`)
};

/**
* | output |
* | --- |
* | "Trusted by" |
*
* @param {Homepage_Banner_Trusted_ByInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_banner_trusted_by = /** @type {((inputs?: Homepage_Banner_Trusted_ByInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Banner_Trusted_ByInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_banner_trusted_by(inputs)
	return en_homepage_banner_trusted_by(inputs)
});